import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { Link } from 'react-router-dom';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import Icon from '../../core/Icon';

// Box general Menu
export const StyledBoxNav = styled.div`
  background-color: ${props => props.theme.colors.light};
  color: ${props => props.theme.colors.light};
  display: flex;
  height: 100%;
  left: 0;
  position: fixed;
  transform: translate(-100%, 0);
  transition-delay: initial;
  transition-duration: 0.4s;
  transition-property: initial;
  transition-timing-function: ease-in-out;
  top: 0;
  z-index: 30;
  /* velo translúcido */
  &:after {
    background-color: ${props => props.theme.colors.dark};
    content: '';
    display: none;
    height: 100%;
    opacity: 0.7;
    position: fixed;
    top: 0;
    width: 600%;
    z-index: -1;
  }
  ${mediaqueries.lessThan('mobile')`
    width: 100%;
  `};
  ${mediaqueries.greaterThan('desktopBig')`
  
  width: ${rem('310px')};
    height: 80vh;
    box-shadow: rgb(0 0 0 / 30%) 1px 3px 0px;
    transform: translate(0, -180%);
    opacity:0;
    padding-bottom:${rem('46px')};
    padding-top:${rem('46px')};
    transition-duration: 0.27s;
    width: 100%;
    /* Parte negra en desktopBig para X */
    &:before {
      background-color: ${props => props.theme.colors.light};
      content: '';
      height: calc(100% + ${rem('73px')});
      position: fixed;
      left:${rem('-11px')};
      top:${rem('-73px')};
      width:${rem('76px')};
      z-index: -1;
    }
  `};
`;

/* capa para menu */
export const StyledMenu = styled.div`
  left: ${rem('13px')};
  position: absolute;
  top: ${rem('56px')};
  display: ${props => !props.show && 'none'};
  ${mediaqueries.greaterThan('desktopBig')`
    left: ${rem('-9px')};
    width: 100%;
  `};
  ${props =>
    props.show &&
    css`
      ${StyledBoxNav} {
        opacity: 1;
        transform: translate(0);
        ${mediaqueries.lessThan('desktopBig')`
          &:after {
            display:block;
          }
        `};
        ${mediaqueries.greaterThan('desktopBig')`
          &:after {
            display:none;
          }
        `};
      }
    `};
`;

/* listado menu */
export const StyledBoxList = styled.ul`
  display: none;
  margin: 0;
  padding: 0;
  ${mediaqueries.lessThan('mobile')`
      margin-top: ${rem('23px')};
  `};
  ${mediaqueries.greaterThan('tablet')`
      margin-bottom: ${rem('6px')};
      margin-top: ${rem('27px')};
  `};
  ${mediaqueries.greaterThan('desktopBig')`
    display: block;
    margin-right: ${rem('2px')};
    margin-top: 0;
  `};
`;

/* capa para distintas columnas del listado */
export const StyledListNav = styled.div`
  background-color: ${props => props.theme.colors.light};
  ${mediaqueries.greaterThan('desktopBig')`
    display:inline-block;
    vertical-align: top;
    margin: 0 0px 0 15px;
    ${props =>
      props.item === "Th'nk" &&
      `
      position: absolute;
      right: 65px;
      top: 100px;    
    `};
  `};
`;

/* icono desplegar opciones del menu */
export const StyledIconDesplegated = styled(Icon)`
  margin-top: ${rem('4px')};
  transform: rotate(90deg);
  ${mediaqueries.lessThan('mobile')`
    margin-top: ${rem('6px')};
  `};
  ${mediaqueries.greaterThan('desktopBig')`
    display:none;
  `};
`;

export const StyledListTitle = styled.button`
  background-color: ${props => props.theme.colors.grayDarkest};
  border: 0;
  color: ${props => props.theme.colors.dark};
  display: flex;
  font-family: ${props => props.theme.fonts.medium};
  font-weight: 900;
  font-size: large;
  height: ${rem('50px')};
  justify-content: space-between;
  margin-bottom: ${rem('4px')};
  padding-left: ${rem('50px')};
  padding-right: ${rem('24px')};
  transition: 0.4s;
  text-align: left;
  width: 100%;
  align-items: center;
  &:focus {
    outline: none;
  }
  ${props =>
    props.show &&
    mediaqueries.lessThan('desktopBig')`
    color: ${props.theme.colors.light};
  `};
  ${mediaqueries.lessThan('desktopBig')`
    ${props =>
      props.open &&
      `> svg {
          fill:${props.theme.colors.primary};
          transform: rotate(-90deg);
        }
        +ul { display:block};
    `};
  `};

  ${mediaqueries.lessThan('mobile')`
    height:${rem('44px')};
    margin-bottom:${rem('2px')};
    padding-left:${rem('40px')};
  `};
  ${mediaqueries.greaterThan('desktopBig')`
    background-color: transparent;
    cursor: default;
    margin-bottom: ${rem('13px')};
    outline:none;
    padding-bottom: ${rem('5px')};;
    padding-left:0;
    padding-right:${rem('5px')};
    width:auto;
    height :auto;
  `};
`;

/* elementos del listado del menu */
export const StyledList = styled.li`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${props => props.theme.fontSize.small};
  list-style: none;
  margin: 0;
  padding-bottom: ${rem('7px')};
  padding-left: ${rem('60px')};

  &:before {
    content: none;
  }

  ${mediaqueries.lessThan('mobile')`
    padding-bottom: ${rem('18px')};
    padding-left:${rem('50px')};
  `};
  ${mediaqueries.greaterThan('desktopBig')`
    padding-bottom: ${rem('7px')};
    padding-left:0;
  `};
`;

/* enlaces menu */
export const StyledListLink = styled.a`
  color: ${props => props.theme.colors.dark};
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${props => props.theme.fontSize.small};
  transition: 0.3s;
  &:hover {
    color: ${props => props.theme.colors.primary};
  }
`;

export const StyledListDiv = styled.div`
  color: ${props => props.theme.colors.dark};
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${props => props.theme.fontSize.small};
  transition: 0.3s;
  &:hover {
    color: ${props => props.theme.colors.primary};
  }
`;

export const StyledListLinkInterno = styled(Link)`
  color: ${props => props.theme.colors.dark};
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${props => props.theme.fontSize.small};
  transition: 0.3s;
  &:hover {
    color: ${props => props.theme.colors.primary};
  }
`;

/* capa para logo navaja e icono cerrar en dispositivos */
export const StyledBoxLogo = styled.div`
  background-color: ${props => props.theme.colors.light};
  display: ${props => (props.mobile ? 'block' : 'flex')};
  ${mediaqueries.lessThan('desktopBig')`
    background-color: transparent;
    height: ${props => (!props.show ? rem('151px') : 'initial')};
  `};
  ${mediaqueries.greaterThan('desktopBig')`
    display: initial;
    height: ${rem('68px')};
  `};
`;

/* icono de cerrar menu */
export const StyledIconClose = styled(Icon)`
  height: ${rem('19px')};
  position: absolute;
  right: ${rem('13px')};
  top: ${rem('13px')};
  width: ${rem('19px')};
  cursor: pointer;
  ${mediaqueries.lessThan('mobile')`
    right: ${props => props.show && rem('26px')};
  `};
  ${mediaqueries.lessThan('desktopBig')`
    right: ${props => (props.show ? rem('48px') : rem('13px'))};
  `};
  ${mediaqueries.greaterThan('desktopBig')`
    fill:${props => props.theme.colors.dark};
    display: flex;
    z-index: 100000;
    justify-content: flex-end;
    height: ${rem('18px')};
    top:${rem('19px')};
  `};
`;

/* capa para menu con scroll en dispositivos */
export const StyledBoxScroll = styled.div`
  height: calc(100% - ${rem('166px')});
  overflow-y: auto;
  ${mediaqueries.lessThan('mobile')`
    height: calc(100% - ${rem('151px')});
  `};
  ${mediaqueries.greaterThan('desktopBig')`
    padding-left:${rem('66px')};
    padding-right:${rem('66px')};
    display: flex;
    justify-content: space-between;    
  `};
`;

/* logo navaja en lateral desplegable */
export const StyledLogoLateral = styled(Icon)`
  width: ${rem('200px')};
  ${mediaqueries.lessThan('mobile')`
    width: ${rem('168px')};
    height: ${rem('70px')};
  `};
  ${mediaqueries.lessThan('desktopBig')`
    width: ${rem('117px')};
  `};
`;
